"use strict";
/**
 * Defines the custom errors used in fqm-execution and the use cases for each one.
 * NOTE: regular Errors are also thrown in certain situations where we have limited
 * information on the crash.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedProperty = exports.UnexpectedProperty = exports.UnexpectedResource = exports.ErrorWithDebugInfo = void 0;
class ErrorWithDebugInfo extends Error {
    constructor(message, debugOutput = undefined) {
        super(message);
        this.debugOutput = debugOutput;
    }
}
exports.ErrorWithDebugInfo = ErrorWithDebugInfo;
/** Thrown when a resource is improperly formatted or empty
ex. patient bundle has no entries, measure bundle has no libraries*/
class UnexpectedResource extends ErrorWithDebugInfo {
    constructor(message, debugOutput = undefined) {
        super(message, debugOutput);
        this.name = 'UnexpectedResource';
    }
}
exports.UnexpectedResource = UnexpectedResource;
/** Used when a resource largely valid/syntactically correct, but has conflicting
info, is impossibly formatted, or is missing specific needed fields
ex. Measure Bundle does not contain improvement notation */
class UnexpectedProperty extends ErrorWithDebugInfo {
    constructor(message, debugOutput = undefined) {
        super(message, debugOutput);
        this.name = 'UnexpectedProperty';
    }
}
exports.UnexpectedProperty = UnexpectedProperty;
/** Used when all resources are valid but are requesting services we do not yet support
ex. user is trying to calculate measure reports with a report type other than 'summary' or 'individual'*/
class UnsupportedProperty extends ErrorWithDebugInfo {
    constructor(message, debugOutput = undefined) {
        super(message, debugOutput);
        this.name = 'UnsupportedProperty';
    }
}
exports.UnsupportedProperty = UnsupportedProperty;
//# sourceMappingURL=CustomErrors.js.map